export default __webpack_public_path__ + "static/media/services-steps-and-coping.65b5aeb4.jpg";